import { useState } from 'react';

interface FarmPlayer {
  rank: number;
  name: string;
  avatar: string;
  region: string;
  level: number;
  levelName: string;
  levelEmoji: string;
  totalHarvests: number;
  plotCount: number;
  topCrop: string;
  topCropEmoji: string;
  score: number;
  weeklyHarvests: number;
}

const FARM_PLAYERS: FarmPlayer[] = [
  {
    rank: 1, name: '陈大学姐（清华）',
    avatar: 'https://public.readdy.ai/ai/img_res/78ef44a3c4da68799308fb3032fda510.jpg',
    region: '北京', level: 5, levelName: '农业大师', levelEmoji: '👑',
    totalHarvests: 128, plotCount: 25, topCrop: '葡萄', topCropEmoji: '🍇', score: 4580, weeklyHarvests: 23,
  },
  {
    rank: 2, name: '王老师',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20middle-aged%20male%20teacher%20portrait%2C%20professional%20look%2C%20glasses%2C%20warm%20smile%2C%20clean%20background&width=60&height=60&seq=fl002&orientation=squarish',
    region: '上海', level: 5, levelName: '农业大师', levelEmoji: '👑',
    totalHarvests: 112, plotCount: 25, topCrop: '苹果', topCropEmoji: '🍎', score: 3920, weeklyHarvests: 18,
  },
  {
    rank: 3, name: '苗家小妹（贵州）',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20Miao%20ethnic%20girl%20student%20portrait%2C%20traditional%20elements%2C%20warm%20smile%2C%20clean%20background&width=60&height=60&seq=fl003&orientation=squarish',
    region: '贵州农村', level: 4, levelName: '农场主', levelEmoji: '🏡',
    totalHarvests: 67, plotCount: 20, topCrop: '雪莲花', topCropEmoji: '🌼', score: 2890, weeklyHarvests: 15,
  },
  {
    rank: 4, name: '小明（北京）',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20boy%20student%20smiling%20portrait%2C%20school%20uniform%2C%20clean%20white%20background&width=60&height=60&seq=fl004&orientation=squarish',
    region: '北京', level: 4, levelName: '农场主', levelEmoji: '🏡',
    totalHarvests: 58, plotCount: 20, topCrop: '西瓜', topCropEmoji: '🍉', score: 2340, weeklyHarvests: 12,
  },
  {
    rank: 5, name: '阿强（云南）',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20rural%20boy%20student%20portrait%2C%20simple%20clothes%2C%20hopeful%20expression%2C%20clean%20background&width=60&height=60&seq=fl005&orientation=squarish',
    region: '云南农村', level: 3, levelName: '丰收达人', levelEmoji: '🌾',
    totalHarvests: 42, plotCount: 16, topCrop: '玉米', topCropEmoji: '🌽', score: 1980, weeklyHarvests: 10,
  },
  {
    rank: 6, name: '张英语老师',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20English%20teacher%20portrait%2C%20professional%20smile%2C%20warm%20expression%2C%20clean%20background&width=60&height=60&seq=fl006&orientation=squarish',
    region: '深圳', level: 3, levelName: '丰收达人', levelEmoji: '🌾',
    totalHarvests: 38, plotCount: 16, topCrop: '草莓', topCropEmoji: '🍓', score: 1760, weeklyHarvests: 9,
  },
  {
    rank: 7, name: '小花（湖南）',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20girl%20student%20smiling%20portrait%2C%20simple%20background%2C%20friendly%20and%20studious%20look&width=60&height=60&seq=fl007&orientation=squarish',
    region: '湖南农村', level: 2, levelName: '勤劳农民', levelEmoji: '🌿',
    totalHarvests: 22, plotCount: 12, topCrop: '番茄', topCropEmoji: '🍅', score: 1340, weeklyHarvests: 7,
  },
  {
    rank: 8, name: '扎西（西藏）',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Tibetan%20boy%20student%20portrait%2C%20Tibet%20rural%20area%2C%20warm%20smile%2C%20simple%20background&width=60&height=60&seq=fl008&orientation=squarish',
    region: '西藏农村', level: 2, levelName: '勤劳农民', levelEmoji: '🌿',
    totalHarvests: 18, plotCount: 12, topCrop: '松果', topCropEmoji: '🌲', score: 1120, weeklyHarvests: 6,
  },
  {
    rank: 9, name: '李学长（北大）',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20male%20university%20student%20portrait%2C%20friendly%20smile%2C%20clean%20background%2C%20casual%20look&width=60&height=60&seq=fl009&orientation=squarish',
    region: '北京', level: 2, levelName: '勤劳农民', levelEmoji: '🌿',
    totalHarvests: 14, plotCount: 12, topCrop: '桃子', topCropEmoji: '🍑', score: 980, weeklyHarvests: 5,
  },
  {
    rank: 10, name: '小雨（贵州）',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20girl%20student%20portrait%2C%20rural%20background%2C%20hopeful%20eyes%2C%20simple%20clothes&width=60&height=60&seq=fl010&orientation=squarish',
    region: '贵州农村', level: 1, levelName: '新手农夫', levelEmoji: '🌱',
    totalHarvests: 7, plotCount: 9, topCrop: '胡萝卜', topCropEmoji: '🥕', score: 560, weeklyHarvests: 4,
  },
];

type SortKey = 'total' | 'weekly' | 'score';

export default function FarmLeaderboard() {
  const [sortKey, setSortKey] = useState<SortKey>('total');
  const [showAll, setShowAll] = useState(false);

  const sorted = [...FARM_PLAYERS].sort((a, b) => {
    if (sortKey === 'total') return b.totalHarvests - a.totalHarvests;
    if (sortKey === 'weekly') return b.weeklyHarvests - a.weeklyHarvests;
    return b.score - a.score;
  }).map((p, i) => ({ ...p, rank: i + 1 }));

  const displayed = showAll ? sorted : sorted.slice(0, 5);

  const rankMedal = (rank: number) => {
    if (rank === 1) return { bg: 'bg-amber-400', text: 'text-white', label: '🥇' };
    if (rank === 2) return { bg: 'bg-gray-300', text: 'text-white', label: '🥈' };
    if (rank === 3) return { bg: 'bg-amber-700', text: 'text-white', label: '🥉' };
    return { bg: 'bg-gray-100', text: 'text-gray-500', label: String(rank) };
  };

  return (
    <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
      {/* Header */}
      <div className="bg-gradient-to-r from-green-600 to-emerald-600 p-4 text-white">
        <div className="flex items-center gap-2 mb-1">
          <i className="ri-trophy-line text-amber-300 text-lg"></i>
          <span className="font-black text-base">农场收获排行榜</span>
        </div>
        <p className="text-white/80 text-xs">多学习多种植，看谁的农场最丰盛！</p>
      </div>

      {/* Sort Tabs */}
      <div className="flex border-b border-gray-100">
        {[
          { key: 'total',  label: '总收获' },
          { key: 'weekly', label: '本周收获' },
          { key: 'score',  label: '积分榜' },
        ].map((tab) => (
          <button
            key={tab.key}
            onClick={() => setSortKey(tab.key as SortKey)}
            className={`flex-1 py-2.5 text-xs font-semibold transition-all cursor-pointer whitespace-nowrap ${
              sortKey === tab.key ? 'text-green-600 border-b-2 border-green-500' : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Top 3 Podium */}
      <div className="p-4 pb-2">
        <div className="flex items-end justify-center gap-3 mb-4">
          {/* 2nd */}
          {sorted[1] && (
            <div className="flex flex-col items-center gap-1 flex-1">
              <img src={sorted[1].avatar} alt={sorted[1].name} className="w-10 h-10 rounded-full object-cover object-top border-2 border-gray-300" />
              <span className="text-lg">{sorted[1].levelEmoji}</span>
              <p className="text-xs font-bold text-gray-700 text-center leading-tight truncate w-full text-center">{sorted[1].name.split('（')[0]}</p>
              <div className="w-full bg-gray-200 rounded-t-lg flex items-center justify-center py-2" style={{ height: '48px' }}>
                <span className="text-xl">🥈</span>
              </div>
            </div>
          )}
          {/* 1st */}
          {sorted[0] && (
            <div className="flex flex-col items-center gap-1 flex-1">
              <div className="relative">
                <img src={sorted[0].avatar} alt={sorted[0].name} className="w-12 h-12 rounded-full object-cover object-top border-2 border-amber-400" />
                <div className="absolute -top-2 left-1/2 -translate-x-1/2 text-lg">👑</div>
              </div>
              <span className="text-lg">{sorted[0].levelEmoji}</span>
              <p className="text-xs font-bold text-gray-900 text-center leading-tight truncate w-full text-center">{sorted[0].name.split('（')[0]}</p>
              <div className="w-full bg-amber-400 rounded-t-lg flex items-center justify-center py-3" style={{ height: '64px' }}>
                <span className="text-2xl">🥇</span>
              </div>
            </div>
          )}
          {/* 3rd */}
          {sorted[2] && (
            <div className="flex flex-col items-center gap-1 flex-1">
              <img src={sorted[2].avatar} alt={sorted[2].name} className="w-10 h-10 rounded-full object-cover object-top border-2 border-amber-700" />
              <span className="text-lg">{sorted[2].levelEmoji}</span>
              <p className="text-xs font-bold text-gray-700 text-center leading-tight truncate w-full text-center">{sorted[2].name.split('（')[0]}</p>
              <div className="w-full bg-amber-700 rounded-t-lg flex items-center justify-center py-1.5" style={{ height: '36px' }}>
                <span className="text-lg">🥉</span>
              </div>
            </div>
          )}
        </div>

        {/* Full List */}
        <div className="flex flex-col gap-2">
          {displayed.map((player) => {
            const medal = rankMedal(player.rank);
            return (
              <div key={player.rank} className={`flex items-center gap-2.5 p-2.5 rounded-xl transition-all ${
                player.rank <= 3 ? 'bg-amber-50 border border-amber-100' : 'hover:bg-gray-50'
              }`}>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-black flex-shrink-0 ${medal.bg} ${medal.text}`}>
                  {player.rank <= 3 ? medal.label : player.rank}
                </div>
                <img src={player.avatar} alt={player.name} className="w-8 h-8 rounded-full object-cover object-top flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-1.5 flex-wrap">
                    <span className="text-xs font-bold text-gray-900 truncate">{player.name.split('（')[0]}</span>
                    <span className="text-xs">{player.levelEmoji}</span>
                    <span className="text-[10px] text-gray-400">{player.levelName}</span>
                  </div>
                  <div className="flex items-center gap-2 mt-0.5">
                    <span className="text-[10px] text-gray-400">{player.region}</span>
                    <span className="text-[10px]">{player.topCropEmoji} 最爱种 {player.topCrop}</span>
                  </div>
                </div>
                <div className="text-right flex-shrink-0">
                  <p className="text-sm font-black text-green-600">
                    {sortKey === 'total' ? player.totalHarvests :
                     sortKey === 'weekly' ? player.weeklyHarvests :
                     player.score.toLocaleString()}
                  </p>
                  <p className="text-[10px] text-gray-400">
                    {sortKey === 'total' ? '次收获' :
                     sortKey === 'weekly' ? '本周' : '积分'}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {!showAll && sorted.length > 5 && (
          <button
            onClick={() => setShowAll(true)}
            className="w-full mt-3 py-2 text-xs font-semibold text-green-600 hover:bg-green-50 rounded-xl transition-colors cursor-pointer"
          >
            查看全部 {sorted.length} 名 <i className="ri-arrow-down-s-line"></i>
          </button>
        )}
        {showAll && (
          <button
            onClick={() => setShowAll(false)}
            className="w-full mt-3 py-2 text-xs font-semibold text-gray-500 hover:bg-gray-50 rounded-xl transition-colors cursor-pointer"
          >
            收起 <i className="ri-arrow-up-s-line"></i>
          </button>
        )}
      </div>

      {/* Motivational Footer */}
      <div className="px-4 pb-4">
        <div className="bg-green-50 rounded-xl p-3 flex items-start gap-2">
          <i className="ri-plant-line text-green-500 text-sm mt-0.5 flex-shrink-0"></i>
          <p className="text-green-700 text-xs leading-relaxed">
            每天学习签到、帮助他人、上传文档都能赚积分，积分越多农场越大，收获越多排名越高！
          </p>
        </div>
      </div>
    </div>
  );
}
